import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { natureOfConstructionOptions, planOnOptions, statesName, yesOrNo } from "../../../TCPForms/data";
import { Col, Container, Row, Table } from "react-bootstrap";
import { Toast } from "@egovernments/digit-ui-react-components";
// import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import { useHistory } from "react-router-dom";
import { Grid } from "@mui/material";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { FaFilePdf } from "react-icons/fa";
import { useSelector } from "react-redux";
import InputWrapper from "../../layout/inputWrapper";
import SortingAlphabatically from "../../reusableComponents/SortingAlphbatically";
import FileUploader from "../../reusableComponents/FileUploader2";
import ButtonWrapper from "../../components/Button";
import { fastPasDa } from "../../components/asset/img";
import { OBPSService } from "../../../../../../../../../packages/libraries/src/services/elements/OBPS";
// import { addYearsToEpoch, convertEpochToDate } from "../../../../../../utils";

const SubStep1 = ({
  formData,
  handleSubTabChange,
  userInfo,
  isEmployee = false,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id,
}) => {
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1");
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [showError, setShowError] = useState(false);
  const tenantId = Digit.ULBService.getStateId();
  const { documents } = useSelector((state) => state.formMT);
  const history = useHistory();
  const inputWidth = 200;
  const checklist = formData?.landInfo?.checklistdata;
  const [error, setError] = useState("");
  const [remarks, setRemarks] = useState("");
  const _khasraNo = formData?.khasraDetails?.[0]?.khasraNumber || formData?.additionalDetails?.khasraDetails?.[0]?.khasraNumber || formData?.khasraNo || "";
  const _plotNo = formData?.additionalDetails?.plotNo || formData?.plotNo || formData?.plotNumbers?.[0] || formData?.additionalDetails?.plotNumbers?.[0] || "";
  const _appNo = formData?.additionalDetails?.applicationNo || formData?.mapSubDetails?.applicationNo || "";
  const _pressReleaseFee = formData?.additionalDetails?.pressReleaseFee || formData?.pressReleaseFee || "";
  const defaultValues = {
    ...formData?.additionalDetails,
    ...formData,
    professionaldetails: { ...(formData?.additionalDetails?.professionaldetails || {}) },
    mapSubDetails: { ...(formData?.mapSubDetails || {}), applicationNo: _appNo },
    pressReleaseDetails: { ...(formData?.pressReleaseDetails || {}), pressReleaseFee: _pressReleaseFee },
    zoneType: formData?.additionalDetails?.zoneType || formData?.zoneType || "",
    subZoneType: formData?.additionalDetails?.subZoneType || formData?.subZoneType || "",
    activityProposed: formData?.additionalDetails?.activityProposed || formData?.activityProposed || "",
    natureOfConstruction: formData?.additionalDetails?.natureOfConstruction || formData?.natureOfConstruction || "",
    schemeName: formData?.additionalDetails?.schemeName || formData?.schemeName || "",
    fastPASId: formData?.additionalDetails?.fastPASId || formData?.land_Id || formData?.fastPASId,
    pressReleaseFee: _pressReleaseFee,
    tehsil: formData?.additionalDetails?.tehsil || formData?.additionalDetails?.locationTehsil || formData?.tehsil || "",
    revenueVillage: formData?.additionalDetails?.revenueVillage || formData?.revenueVillage || "",
    plotArea: formData?.additionalDetails?.plotArea || formData?.plotArea || "",
    plotAreaDoc: formData?.additionalDetails?.plotAreaDoc || formData?.plotAreaDoc || "",
    primaryUse: formData?.additionalDetails?.primaryUse || formData?.primaryUse || "",
    landMark: formData?.additionalDetails?.landMark || formData?.landMark || "",
    proposalType: formData?.additionalDetails?.proposal || formData?.proposalType || "",
    khasraNo: _khasraNo,
    plotNo: _plotNo,
    isSpecialProject: formData?.additionalDetails?.isSpecialProject || formData?.isSpecialProject,
    groundCoverages: formData?.groundCoverages,
    fars: formData?.fars,
    buildingHeight: formData?.buildingHeight,
    previousSetbackFront: formData?.setbackFronts,
    previousSetbackRear: formData?.setbackRears,
    natureOfConstructionOptions: formData?.natureOfConstructionOptions,
  };
  const { handleSubmit, control, setValue, watch, reset, getValues, clearErrors } = useForm({ defaultValues });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  const [fastPASData, setFastPasData] = useState(Digit?.SessionStorage.get("EMP_MAPSUB") || null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const { data, isLoading: isDropDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && data?.MapSubmission?.DropdownsConfig?.[0];
  const [schemeType, setSchemeType] = useState(false);
  const [dwgPdf, setDwgPdf] = useState(null);
  const [dwgPdfUrl, setDwgPdfUrl] = useState(formData?.drawingPdf);
  const [approvalUrl, setApprovalUrl] = useState(formData?.approvalCertificateUrl);
  const validateFiles = () => {
    const uploadedDocs = new Set(documents?.map((doc) => doc.documentType)); // Using Set for faster lookups
    const requiredDocs = ["drawingPdf"];
    return requiredDocs.every((doc) => uploadedDocs.has(doc)); // Use Set.has for O(1) lookup
  };
  const handleFormSubmit = (data) => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitinsideIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  const [
    watchPlanOn,
    watchnatureOfConstruction,
    watchlandUseType,
    watchSubZoneType,
    watchPrimaryUse,
    watchAtivityProposed,
    watchLandMark,
    watchState,
    watchCity,
    watchPin,
    watchAddress,
    watchConsultantCateogry,
    watchProfName,
    watchProfEmailId,
    watchProfMobileNo,
    watchCertNo,
    watchValidUpto,
    watchName,
    watchMobileNo,
    watchEmailId,
    watchProposalType,
    watchSchemeName,
    watchTehsil,
    watchVillage,
    watchSectorNo,
    watchKhasraNo,
    watchPlotNo,
    watchLatitude,
    watchLongitude,
    watchApplication,
    watchLayoutSanctionDate,
    watchValidity,
    watchPressReleaseFee,
  ] = watch([
    "planOn",
    "natureOfConstruction",
    "zoneType",
    "subZoneType",
    "primaryUse",
    "activityProposed",
    "landMark",
    "landInfo.owners.[0].correspondenceAddress.state",
    "landInfo.owners.[0].correspondenceAddress.town",
    "landInfo.owners.[0].correspondenceAddress.pinno",
    "landInfo.owners.[0].correspondenceAddress.address",
    "professionaldetails.consultantCategory",
    "professionaldetails.name",
    "professionaldetails.emailId",
    "professionaldetails.mobileNumber",
    "professionaldetails.certificateNo",
    "professionaldetails.validupto",
    "landInfo.owners.[0].name",
    "landInfo.owners.[0].mobileNumber",
    "landInfo.owners.[0].emailId",
    "proposalType",
    "schemeName",
    "tehsil",
    "revenueVillage",
    "sectorNo",
    "khasraNo",
    "plotNo",
    "descriptionOfLand.latitude",
    "descriptionOfLand.longitude",
    "mapSubDetails.applicationNo",
    "layoutsanctionDate",
    "validity",
    "pressReleaseFee",
  ]);

  useEffect(() => {
    if (formData) {
      const khasraNo = formData?.khasraDetails?.[0]?.khasraNumber || formData?.additionalDetails?.khasraDetails?.[0]?.khasraNumber || formData?.khasraNo || "";
      const plotNo = formData?.additionalDetails?.plotNo || formData?.plotNo || formData?.plotNumbers?.[0] || formData?.additionalDetails?.plotNumbers?.[0] || "";
      const appNo = formData?.additionalDetails?.applicationNo || formData?.mapSubDetails?.applicationNo || "";
      const pressReleaseFee = formData?.additionalDetails?.pressReleaseFee || formData?.pressReleaseFee || "";
      reset({
        ...formData?.additionalDetails,
        ...formData,
        professionaldetails: {
          ...(formData?.additionalDetails?.professionaldetails || {}),
        },
        mapSubDetails: { ...(formData?.mapSubDetails || {}), applicationNo: appNo },
        pressReleaseDetails: { ...(formData?.pressReleaseDetails || {}), pressReleaseFee },
        zoneType: formData?.additionalDetails?.zoneType || formData?.zoneType || "",
        subZoneType: formData?.additionalDetails?.subZoneType || formData?.subZoneType || "",
        activityProposed: formData?.additionalDetails?.activityProposed || formData?.activityProposed || "",
        natureOfConstruction: formData?.additionalDetails?.natureOfConstruction || formData?.natureOfConstruction || "",
        schemeName: formData?.additionalDetails?.schemeName || formData?.schemeName || "",
        fastPASId: formData?.additionalDetails?.fastPASId || formData?.land_Id || formData?.fastPASId,
        pressReleaseFee,
        tehsil: formData?.additionalDetails?.tehsil || formData?.additionalDetails?.locationTehsil || formData?.tehsil || "",
        revenueVillage: formData?.additionalDetails?.revenueVillage || formData?.revenueVillage || "",
        plotArea: formData?.additionalDetails?.plotArea || formData?.plotArea || "",
        plotAreaDoc: formData?.additionalDetails?.plotAreaDoc || formData?.plotAreaDoc || "",
        primaryUse: formData?.additionalDetails?.primaryUse || formData?.primaryUse || "",
        landMark: formData?.additionalDetails?.landMark || formData?.landMark || "",
        proposalType: formData?.additionalDetails?.proposal || formData?.proposalType || "",
        khasraNo,
        plotNo,
      });
    }
  }, [formData, reset]);

  useEffect(() => {
    const alldocs = fastPASData?.documents;
    if (Array.isArray(alldocs) && Array.isArray(documents) && !isEmployee) {
      const mergedDocs = [...(alldocs || []), ...(documents || [])];
      setValue("documents", mergedDocs);
    }
    if (isEmployee) {
      setValue("documents", documents);
    }
  }, [documents]);

  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const handleSearchClick = async (applicationNo) => {
    try {
      let response;
      let data;
      let purchasableData;
      const id = applicationNo.replace(/[-/]/g, "");
      if (applicationNo) {
        response = await OBPSService.BPASearch(tenantId, { applicationNo });
        console.log(response, "responsefromId");
        if (response?.BPA?.length === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this Application No...!!`,
          });
          return;
        }
        data = response?.BPA?.[0];
        // if (!data?.status?.includes("APPROVED")) {
        //   setShowToast({
        //     key: "true",
        //     error: true,
        //     message: `Application is not Approved Yet...!!`,
        //   });
        //   return;
        // }
        setFastPasData(data);
        const drawingPdfs = data?.documents?.filter((e) => e.documentType === "drawingPdf");
        setDwgPdf(drawingPdfs?.[0]?.fileStoreId);
        if (data) {
          // const uuid = userInfo?.uuid;
          // if (uuid) {
          //   const usersResponse = await Digit.UserService.userSearch(tenantId, { uuid: [uuid] }, {});
          //   const userDetail = usersResponse?.user?.[0];
          //   Digit.SessionStorage.set("USER_DETAIL", userDetail);
          //   setUser(userDetail);
          //   if (data?.additionalDetails?.professionalInformation?.mobileNumber === userDetail?.mobileNumber) {
          //     setShowToast({
          //       key: "true",
          //       error: false,
          //       message: `Data fetched Successfully...!!`,
          //     });
          //   }
          setDwgPdfUrl(data?.drawingPdf);
          setApprovalUrl(data?.approvalCertificateUrl);
          setShowToast({
            key: "true",
            error: false,
            message: `Data fetched Successfully...!!`,
          });
        }
        console.log("loggingDataFromSearch", data);
        setValue("zoneType", data?.zoneType);
        setValue("primaryUse", data?.primaryUse);
        setValue("landMark", data?.descriptionOfLand?.landMark);
        setValue("sectorNo", data?.descriptionOfLand?.sectorNo);
        setValue("khasraNo", data?.descriptionOfLand?.khasraWithArea[0]?.khasraNo);
        setValue("schemeName", data?.descriptionOfLand?.schemeName);
        setValue("natureOfConstruction", data?.natureOfConstruction);
        setValue("sanctionNumber", data?.sanctionNumber);
        const lastModifiedTime = data?.auditDetails?.lastModifiedTime;
        // setValue("layoutsanctionDate", convertEpochToDate(lastModifiedTime));
        // setValue("validity", convertEpochToDate(addYearsToEpoch(lastModifiedTime, 5)));
        setValue("revenueVillage", data?.revenueVillage);
        setValue("landMark", data?.landMark);
        setValue("sectorNo", data?.sectorNo);
        setValue("khasraNo", data?.khasraNo);
        setValue("plotNo", data?.plotNo);
        setValue("descriptionOfLand.latitude", data?.descriptionOfLand?.latitude);
        setValue("descriptionOfLand.longitude", data?.descriptionOfLand?.longitude);
        setValue("descriptionOfLand.schemeType", data?.descriptionOfLand?.schemeType);
        setValue("schemeName", data?.descriptionOfLand?.schemeName);
        setValue("riskType", data?.riskType);
        setValue("pressReleaseDetails.pressReleaseFee", data?.pressReleaseFee);
        setValue("department", data?.department);
        setValue("activityProposed", data?.activityProposed);
        setValue("proposalType", data?.proposal);
        setValue("plotArea", data?.descriptionOfLand?.landArea);
        setValue("plotAreaDoc", data?.descriptionOfLand?.plotAreaDoc);
        setValue("plotAreaPos", data?.descriptionOfLand?.plotAreaPossession);
        setValue("siteAddress", data?.descriptionOfLand?.landAddress);
        setValue("tehsil", data?.tehsil);
        setValue("typeOfArea", data?.descriptionOfLand?.developmentArea);
        setValue("subZoneType", data?.subZoneType);

        setValue("professionaldetails.consultantCategory", data?.professionaldetails?.consultantCategory);
        setValue("professionaldetails.name", data?.professionaldetails?.name);
        setValue("professionaldetails.emailId", data?.professionaldetails?.emailId);
        setValue("professionaldetails.mobileNumber", data?.professionaldetails?.mobileNumber);
        setValue("professionaldetails.certificateNo", data?.professionaldetails?.certificateNo);
        setValue("professionaldetails.validupto", data?.professionaldetails?.validupto);

        setValue("landInfo.owners.[0].name", data?.landInfo?.owners?.[0]?.name);
        setValue("landInfo.owners.[0].emailId", data?.landInfo?.owners?.[0]?.emailId);
        setValue("landInfo.owners.[0].mobileNumber", data?.landInfo?.owners?.[0]?.mobileNumber);
        setValue("landInfo.owners.[0].correspondenceAddress.state", data?.landInfo?.owners?.[0]?.correspondenceAddress?.state);
        setValue("landInfo.owners.[0].correspondenceAddress.town", data?.landInfo.owners?.[0]?.correspondenceAddress?.town);
        setValue("landInfo.owners.[0].correspondenceAddress.pinno", data?.landInfo.owners?.[0]?.correspondenceAddress?.pinno);
        setValue("landInfo.owners.[0].correspondenceAddress.address", data?.landInfo.owners?.[0]?.correspondenceAddress?.address);

        if (!data?.pressReleaseFee) {
          setShowToast({
            key: "true",
            error: true,
            message: `Invitation suggestion is not required for this proposal.`,
          });
        }
        clearErrors([
          "zoneType",
          "primaryUse",
          "landMark",
          "sectorNo",
          "khasraNo",
          "schemeName",
          "planOn",
          "riskType",
          "activityProposed",
          "plotArea",
          "plotAreaDoc",
          "plotNo",
          "plotAreaPos",
          "landAddress",
          "tehsil",
          "typeOfArea",
          "subZoneType",
          "latitude",
          "longitude",
          "roadwidth",
          "schemeType",
          "ConstructionType",
          "district",
          "professionaldetails.name",
          "professionaldetails.mobileNumber",
        ]);
        const isApproved = data?.descriptionOfLand?.schemeType === "Scheme";
        setSchemeType(isApproved);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const filterSchemeData = (authority, masterData, category, subCategory) => {
    // First, find the relevant data once and store it
    const authorityData = masterData?.find((item) => item.name === authority);

    if (!authorityData) return { landUseList: [], landSubUseList: null }; // Return early if no authority data is found

    // Calculate landUseList, which doesn't depend on category
    const landUseList =
      authorityData?.LandUse?.map((item) => ({
        name: item.Type,
        value: item.Type,
      })) || []; // Fallback to an empty array if no LandUse is found

    let landSubUseList = null;

    // Only calculate landSubUseList if category is provided
    if (category) {
      const landUseCategory = authorityData?.LandUse?.find((item) => item.Type === category);

      // Only process if the specific category is found
      if (landUseCategory) {
        landSubUseList =
          landUseCategory.LandSubUse?.map((item) => ({
            name: item,
            label: item,
          })) || []; // Fallback to empty array if LandSubUse is not found
      }
    }

    console.log("loggingMasterData", landUseList, landSubUseList);

    return { landUseList, landSubUseList };
  };

  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    console.log("FromNonschemeDataCalled", masterData, category);

    const landUseList = masterData?.[0]?.CategeryType?.map((item) => {
      return { name: item.Categery, label: item.Categery };
    });
    const landSubUseList = masterData?.[0]?.CategeryType?.filter((item) => item.Categery === category)?.[0]?.["Activity Proposed"]?.map((item) => {
      return { name: item, label: item };
    });

    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return { landUseList, landSubUseList };
  };
  const { landUseList, landSubUseList } = !schemeType
    ? filterSchemeData(fastPASData?.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType)
    : filterNonSchemeData(fastPASData?.selectedOffice, nonSchemeTypeData, watchlandUseType, watchSubZoneType);
  const isDA = fastPASData?.department === "DA";
  const onSubmit = (data) => {
    const pressFee = data?.pressReleaseDetails?.pressReleaseFee || data?.pressReleaseFee || "";
    const sug = data?.hasSuggestion || data?.pressReleaseDetails?.hasSuggestion || "";

    const pressDetailsObj = {
      ...(fastPASData?.pressDetails || {}),
      ...(fastPASData?.pressReleaseDetails || {}),
      ...(data?.pressReleaseDetails || {}),
      ...(data?.pressDetails || {}),
      pressReleaseFee: pressFee,
      hasSuggestion: sug,
    };

    let final = {
      ...fastPASData,
      ...data,
      pressReleaseFee: pressFee,
      hasSuggestion: sug,
      pressDetails: pressDetailsObj,
      pressReleaseDetails: pressDetailsObj,
      landInfo: {
        ...data.landInfo,
        tenantId: "up",
        address: fastPASData?.landInfo?.address || data.landInfo?.address,
      },
    };

    if (isEmployee) {
      handleTabChange(2, final);
    } else {
      handleTabChange(1, final);
    }
  };

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="formContainer">
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="Application No"
                  placeholder="Enter Application No"
                  name="mapSubDetails.applicationNo"
                  type="textInput"
                  mandatory
                  defaultValue={formData?.mapSubDetails?.applicationNo}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                  showSearchIcon={true}
                  onSearchClick={() => handleSearchClick(getValues("mapSubDetails.applicationNo"))}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Licensed Technical Person (LTP)")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Consultant Category")}`}
                  placeholder={`${t("Consultant Category")}`}
                  name="professionaldetails.consultantCategory"
                  defaultValue={formData?.professionaldetails?.consultantCategory}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee | fastPASData?.professionaldetails?.consultantCategory}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("LABEL_APPLICANT_NAME")}
                  control={control}
                  placeholder={t("LABEL_ENTER_NAME")}
                  name="professionaldetails.name"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.professionaldetails?.name}
                  type="textInput"
                  // validation={{
                  //   required: {
                  //     value: true,
                  //     message: "This field is required",
                  //   },
                  //   pattern: {
                  //     value: Digit.Utils.getPattern("Name"),
                  //     message: "Please enter only letters and spaces",
                  //   },
                  // }}
                  disabled={isEmployee || fastPASData?.professionaldetails?.name}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                {" "}
                <InputWrapper
                  label={t("LABEL_EMAIL_ID")}
                  control={control}
                  placeholder={t("LABEL_ENTER_APPLICANT_EMAIL_ID")}
                  name="professionaldetails.emailId"
                  // defaultValue={formData?.professionaldetails?.emailId}
                  type="textInput"
                  mandatory
                  maxLength={25}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Email"),
                      message: "Please enter valid email id",
                    },
                  }}
                  disabled={isEmployee || fastPASData?.professionaldetails?.emailId}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("Enter Mobile No")}
                  control={control}
                  placeholder={t("Mobile No")}
                  mobileNumber
                  mandatory
                  type="textInput"
                  name="professionaldetails.mobileNumber"
                  // defaultValue={formData?.professionaldetails?.mobileNumber}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("MobileNo"),
                      message: "Please enter valid mobile no",
                    },
                  }}
                  maxLength={10}
                  disabled={isEmployee || fastPASData?.professionaldetails?.mobileNumber}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                {" "}
                <InputWrapper
                  label="Certificate No. (For Minimum Qualification)"
                  control={control}
                  placeholder="Enter Certificate No"
                  maxLength={13}
                  type="textInput"
                  name="professionaldetails.certificateNo"
                  defaultValue={formData?.professionaldetails?.certificateNo}
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("LABEL_VALID_UPTO")}
                  control={control}
                  placeholder="Select Date"
                  type="datePicker"
                  name="professionaldetails.validupto"
                  defaultValue={formData?.professionaldetails?.validupto}
                  disabled={isEmployee || watchValidUpto}
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Owner Information")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                {" "}
                <InputWrapper
                  label={t("Name")}
                  control={control}
                  placeholder={t("LABEL_ENTER_NAME")}
                  name="landInfo.owners.[0].name"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.landInfo?.owners?.[0]?.name}
                  type="textInput"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  disabled={isEmployee || watchName}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("Enter Mobile No")}
                  control={control}
                  placeholder={t("Mobile No")}
                  mobileNumber
                  mandatory
                  type="textInput"
                  name="landInfo.owners.[0].mobileNumber"
                  defaultValue={formData?.landInfo?.owners?.[0]?.mobileNumber}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("MobileNo"),
                      message: "Please enter valid mobile no",
                    },
                  }}
                  maxLength={10}
                  disabled={isEmployee || watchMobileNo}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("LABEL_EMAIL_ID")}
                  control={control}
                  placeholder={t("LABEL_ENTER_APPLICANT_EMAIL_ID")}
                  name="landInfo.owners.[0].emailId"
                  defaultValue={formData?.landInfo?.owners?.[0]?.emailId}
                  type="textInput"
                  mandatory
                  maxLength={25}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Email"),
                      message: "Please enter valid email id",
                    },
                  }}
                  disabled={isEmployee || watchEmailId}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_STATE")}
                  placeholder={t("LABEL_ENTER_STATE")}
                  name="landInfo.owners.[0].correspondenceAddress.state"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.state}
                  type="selectInput"
                  data={statesName}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchState}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={updistricts}
                  label={t("LABEL_CITY")}
                  placeholder={watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY")}
                  name="landInfo.owners.[0].correspondenceAddress.town"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.town}
                  type={watchState === "Uttar Pradesh" ? "selectInput" : "textInput"}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchCity}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_PINCODE")}
                  placeholder={t("LABEL_ENTER_PINCODE")}
                  name="landInfo.owners.[0].correspondenceAddress.pinno"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Pincode"),
                      message: "Please enter valid Pincode",
                    },
                  }}
                  maxLength={6}
                  disabled={isEmployee || watchPin}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  label={t("LABEL_ADDRESS")}
                  placeholder={t("LABEL_ENTER_ADDRESS")}
                  name="landInfo.owners.[0].correspondenceAddress.address"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Address"),
                      message: "Please enter valid Address",
                    },
                  }}
                  maxLength={50}
                  disabled={isEmployee || watchAddress}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Plot Details")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Land Use")}
                  placeholder={t("Select Type of Land")}
                  name="zoneType"
                  defaultValue={formData?.zoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchlandUseType}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Land Sub Use")}
                  placeholder={t("Select Type of Land Subuse")}
                  name="subZoneType"
                  defaultValue={formData?.subZoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchSubZoneType}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Primary Use of Proposed Activity")}
                  placeholder={t("Select Primary Use of Proposed Activity")}
                  name="primaryUse"
                  defaultValue={formData?.primaryUse}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchPrimaryUse}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Activity proposed")}
                  placeholder={t("Select Type of Activity proposed")}
                  name="activityProposed"
                  defaultValue={formData?.activityProposed}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchAtivityProposed}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(planOnOptions)}
                  label={t("Proposed Site")}
                  placeholder={t("Proposed Site")}
                  name="proposalType"
                  defaultValue={formData?.proposalType}
                  type="selectInput"
                  disabled={isEmployee || watchProposalType}
                />
              </Col>
              {watchPlanOn === "Others" ? (
                <Col>
                  <InputWrapper
                    label={"Other Proposed Site"}
                    control={control}
                    placeholder={t("Enter Proposed Site")}
                    name="otherSchemeName"
                    mandatory
                    defaultValue={formData?.otherSchemeName}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label={t("Sanction No.")}
                  control={control}
                  placeholder={t("Enter sanction number")}
                  name="mapSubDetails.applicationNo"
                  defaultValue={formData?.mapSubDetails?.applicationNo || watchApplication}
                  type="textInput"
                  disabled={isEmployee || watchApplication}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Sanction Date")}
                  control={control}
                  placeholder={t("Enter Sanction date")}
                  name="layoutsanctionDate"
                  defaultValue={formData?.layoutsanctionDate}
                  type="datePicker"
                  disabled={isEmployee || watchLayoutSanctionDate}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Nature of Construction /Case Type")}
                  placeholder={t("Select Nature Of Construction")}
                  name="natureOfConstruction"
                  defaultValue={formData?.natureOfConstruction}
                  data={SortingAlphabatically(natureOfConstructionOptions)}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchnatureOfConstruction}
                />
              </Col>

              <Col>
                <InputWrapper
                  label={t("Validity")}
                  control={control}
                  placeholder={t("Select Validity")}
                  name="validity"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.validity}
                  type="datePicker"
                  disabled={isEmployee || watchValidity}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label="Scheme Name"
                  control={control}
                  placeholder="Select Scheme Name"
                  defaultValue={formData?.schemeName}
                  name={`schemeName`}
                  type="selectInput"
                  mandatory
                  data={SortingAlphabatically(dropDownData?.schemeName)}
                  disabled={isEmployee || watchSchemeName}
                />
              </Col>
              <Col>
                <InputWrapper
                  label="Tehsil"
                  control={control}
                  placeholder="Enter Tehsil"
                  defaultValue={formData?.tehsil}
                  name={`tehsil`}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label="Revenue Village/Colony Name"
                  control={control}
                  placeholder="Enter Revenue Village"
                  defaultValue={formData?.revenueVillage}
                  name={`revenueVillage`}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Land Mark")}
                  control={control}
                  placeholder={t("Enter Land Mark")}
                  name="landMark"
                  maxLength={15}
                  defaultValue={formData?.landMark}
                  type="textInput"
                  disabled={isEmployee || watchLandMark}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("Sector/Pocket No.")}
                  control={control}
                  placeholder={t("Enter Sector/Pocket No.")}
                  name="sectorNo"
                  maxLength={15}
                  defaultValue={formData?.sectorNo}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Khasra No.")}
                  control={control}
                  placeholder={t("Enter Khasra No.")}
                  name="khasraNo"
                  maxLength={15}
                  defaultValue={formData?.khasraNo}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("Plot No")}
                  control={control}
                  placeholder={t("Enter Plot no")}
                  name="plotNo"
                  mandatory
                  defaultValue={formData?.plotNo}
                  type="textInput"
                  disabled={isEmployee || watchPlotNo}
                />
              </Col>
              <Col className="custom-upload new-custom-uploader"></Col>
            </Row>

            {/* <Row>
              <Col>
                <InputWrapper
                  label={t("Date of press release")}
                  control={control}
                  placeholder={t("Select date")}
                  name="pressReleaseDate"
                  defaultValue={formData?.pressReleaseDate}
                  type="datePicker"
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Closing date for submissions")}
                  control={control}
                  placeholder={t("Select date")}
                  name="closingDate"
                  defaultValue={formData?.closingDate}
                  type="datePicker"
                  disabled={isEmployee}
                />
              </Col>
            </Row> */}
          </Container>
        </div>
        {!isEmployee && (
          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Document Section")}</h2>
            </div>{" "}
            <Container fluid className="formInputContainer common-app-form">
              <Row>
                <Col className="custom-upload new-custom-uploader">
                  <FileUploader
                    isMandatory
                    label={t("Map PDF")}
                    control={control}
                    name="drawingPdf"
                    showError={showError}
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    required
                  />
                </Col>
                <Col></Col>
              </Row>
            </Container>
          </div>
        )}
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Fee Details")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  label={t("Press Release Fee")}
                  control={control}
                  placeholder={t("Press Release Fee")}
                  name="pressReleaseDetails.pressReleaseFee"
                  mandatory
                  defaultValue={formData?.pressReleaseFee}
                  type="textInput"
                  disabled={isEmployee || watchPressReleaseFee}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>
        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </section>
  );
};

export default SubStep1;
